import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

const Contact = () => {

    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });


    return (

        <>
            <Helmet>
                <title>WEAREBIAM | CONTACT</title>
                <meta name="description" content="Get In Touch." />

                {/* Open Graph */}
                <meta property="og:title" content="WEAREBIAM | CONTACT" />
                <meta property="og:description" content="Get In Touch." />
                <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/werebiam.firebasestorage.app/o/assets%2Fwebcover_bw.png?alt=media&token=f3686ce5-b347-4f99-8b23-0f52d461675c" />
                <meta property="og:url" content="https://wearebiam.com/contact" />
                <meta property="og:type" content="website" />

            </Helmet>

            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.6 }}
                className='flex flex-col sm:items-center sm:justify-center sm:gap-[80px] gap-5 w-full sm:h-[100dvh] bg-white lg:px-[10rem] px-[1.25rem] lg:pt-0 pt-[8rem]'
            >

                <div className="flex sm:flex-row flex-col lg:gap-[80px] gap-5 sm:items-center sm:justify-center w-full">
                    <p className="text-black font-extrabold lg:text-center leading-none lg:text-[112px] text-[64px]">
                        GET IN <br />
                        TOUCH
                    </p>

                    <div className="flex flex-col gap-10">
                        <motion.div
                            ref={ref}
                            className="flex flex-col uppercase"
                            initial={{ opacity: 0, y: 40 }}
                            animate={isInView ? { opacity: 1, y: 0 } : {}}
                            transition={{ duration: 0.6, ease: 'easeOut' }}
                        >
                            <p className='lg:text-[12px] text-[10px]'>WANTS TO KNOW MORE ABOUT US? HIT UP!</p>

                            <motion.a
                                href="mailto:hello@wearebiam.com"
                                className="font-bold relative w-fit lg:text-[25px] text-[18px] inline-block"
                                initial={{ x: 0 }}
                                whileHover={{ x: -25, transition: { type: "tween", duration: 0.10, ease: "easeOut" } }}
                                animate={{ x: 0, transition: { type: "tween", duration: 0.4, ease: "easeInOut" } }}
                            >
                                hello@wearebiam.com
                                <motion.span
                                    className="absolute left-0 bottom-0 h-[2px] w-full bg-black origin-left"
                                    initial={{ scaleX: 0 }}
                                    whileHover={{ scaleX: 1 }}
                                    transition={{ duration: 0.3 }}
                                />
                            </motion.a>


                        </motion.div>

                    </div>
                </div>

                <div className="flex lg:flex-row flex-col lg:gap-[100px] gap-10 sm:items-center sm:justify-center w-full">

                    <motion.a
                        href="https://www.instagram.com/wearebiam"
                        target="_blank" rel="noopener noreferrer"
                        className="relative w-fit lg:text-[14px] text-[16px] hover:font-bold inline-block"
                    >
                        INSTAGRAM
                    </motion.a>

                    <motion.a
                        href="https://www.linkedin.com/company/wearebiam/"
                        target="_blank" rel="noopener noreferrer"
                        className="relative w-fit lg:text-[14px] text-[16px] hover:font-bold inline-block"
                    >
                        LINKEDIN
                    </motion.a>

                    <motion.a
                        href="https://www.youtube.com/@wearebiam"
                        target="_blank" rel="noopener noreferrer"
                        className="relative w-fit lg:text-[14px] text-[16px] hover:font-bold inline-block"
                    >
                        YOUTUBE
                    </motion.a>

                    <Link
                        to={"/"}
                        className="relative w-fit lg:text-[14px] text-[16px] hover:font-bold inline-block"
                    >
                        HOME
                    </Link>

                </div>

            </motion.div>
        </>

    );
};

export default Contact;